// extracted by mini-css-extract-plugin
export default {"container":"beforeSearch_container__XdXEB","button":"beforeSearch_button__CqmDL"};